if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();

      this.scrollMode = this.dataset.scrollMode || 'auto';
      this.promotion  = this.querySelector('.promotion');

      // motionReduced only skips the CSS marquee animation.
      // The manual Swiper slider is not an animation, so it always inits.
      if (this.scrollMode === 'auto' && FoxTheme.config.motionReduced) return;

      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    init() {
      if (this.scrollMode === 'manual') {
        this.initManualSlider();
      } else {
        this.initAutoScroll();
      }
    }

    /* ── Automatic marquee scroll (original behaviour) ─────────────────── */
    initAutoScroll() {
      if (!this.promotion.classList.contains('promotion--animated')) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    /* ── Manual Swiper slider with dot navigation ───────────────────────── */
    initManualSlider() {
      const manualItems = parseInt(this.dataset.manualItems) || 4;

      // Reuse the section's spacing CSS vars — desktop and mobile variants
      const hSpacingRaw    = window.getComputedStyle(this).getPropertyValue('--h-spacing').trim();
      const hSpacingMobile = window.getComputedStyle(this).getPropertyValue('--h-spacing-mobile').trim();
      const spaceBetween   = parseFloat(hSpacingRaw)    || 20;
      const spaceMobile    = parseFloat(hSpacingMobile) || Math.min(spaceBetween, 24);

      const sliderOptions = {
        slidesPerView: 1,
        spaceBetween: spaceMobile,   // mobile uses the capped mobile value
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: false,
        loop: false,
        threshold: 2,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: spaceBetween,
          },
          768: {
            slidesPerView: Math.min(manualItems, 3),
            spaceBetween: spaceBetween,
          },
          1280: {
            slidesPerView: manualItems,
            spaceBetween: spaceBetween,
          },
        },
      };

      // `this` already has the `swiper` class and `.promotion` already has
      // `swiper-wrapper` — both set in the Liquid template.
      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      // Theme Editor: clicking a block navigates to its slide
      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const index = Number(e.target.dataset.index);
          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.slideTo(index);
          }
        });
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }

  customElements.define('scrolling-promotion', ScrollingPromotion);
}
